import SearchDiagnosticsStore from './schema/SearchDiagnosticsStore';
import { declareDiagnostics } from 'owa-diagnostics';
import { mutator } from 'satcheljs';
import { addE2ETimeToDiagnosticsStore } from '../actions/addE2ETimeToDiagnosticsStore';
import { addSearchRequestInstrumentation } from '../actions/addSearchRequestInstrumentation';
import { addResourceTimingEntry } from '../actions/addResourceTimingEntry';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import insertInstrumentationInList from '../helpers/insertInstrumentationInList';

const initialSearchDiagnostics: SearchDiagnosticsStore = {
    searchInstrumentationList: [],
};

export const searchDiagnostics = declareDiagnostics(
    'SearchDiagnostics',
    initialSearchDiagnostics,
    searchDiagnosticsStore => {
        mutator(addE2ETimeToDiagnosticsStore, ({ jsEndToEndTime, jsRenderingTime }) => {
            // add this JS time to searchInstrumentation entry for page Number 0 so that we show right number on diagnostics header
            for (const instrumentation of searchDiagnosticsStore.searchInstrumentationList) {
                if (
                    instrumentation.PageNumber == 0 &&
                    instrumentation.SearchQueryId ==
                        getScenarioStore(SearchScenarioId.Calendar).currentSearchQueryId
                ) {
                    instrumentation.ClientJSEndToEndTime = jsEndToEndTime;
                    instrumentation.ClientJSRenderingTime = jsRenderingTime;
                    break;
                }
            }
        });

        mutator(addSearchRequestInstrumentation, ({ searchRequestInstrumentation }) => {
            insertInstrumentationInList(
                searchRequestInstrumentation,
                searchDiagnosticsStore.searchInstrumentationList
            );
        });

        mutator(
            addResourceTimingEntry,
            ({ searchInstrumentationEntry, resourceTimingEntry, executeSearchDatapoint }) => {
                searchInstrumentationEntry.ResourceTimingEntry = resourceTimingEntry;

                // The end to end datapoint only exists for page 0 requests
                if (executeSearchDatapoint) {
                    searchInstrumentationEntry.ClientJSEndToEndTime =
                        executeSearchDatapoint.waterfallTimings['ClientJSEndToEndTime'];
                }
            }
        );
    }
);
